import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import VRGroup from './pages/VRGroup';
import Utility from './pages/Utility';
import Career from './pages/Career';
import Contact from './pages/Contact';
import Mining from './pages/Mining';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/vr-group" element={<VRGroup />} />
          <Route path="/utility" element={<Utility />} />
          <Route path="/career" element={<Career />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/mining" element={<Mining />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
